import axios, { type AxiosRequestConfig } from 'axios'

type ApiEnvelope<T> = {
  code: number
  data: T
  message: string
}

// 使用相对路径，通过 Vite 代理转发到后端
export const api = axios.create({
  baseURL: '/api',
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
})

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('client_token')
  if (token)
    config.headers.Authorization = `Bearer ${token}`
  if (typeof FormData !== 'undefined' && config.data instanceof FormData)
    delete config.headers['Content-Type']
  return config
})

// 响应拦截器
api.interceptors.response.use(
  response => response.data,
  (error) => {
    const payload = error?.response?.data as { message?: string | string[] } | undefined
    const raw = payload?.message
    const message = Array.isArray(raw) ? raw[0] : (raw || error?.message || '请求失败')
    return Promise.reject(new Error(String(message)))
  },
)

function isApiEnvelope(value: unknown): value is ApiEnvelope<unknown> {
  return typeof value === 'object'
    && value !== null
    && 'code' in value
    && 'data' in value
}

async function unwrap<T>(response: unknown): Promise<T> {
  if (!isApiEnvelope(response)) {
    throw new Error('接口返回格式不正确')
  }
  if (response.code !== 0 && response.code !== 200) {
    throw new Error(response.message || '请求失败')
  }
  return response.data as T
}

export async function getApiData<T>(url: string, config?: AxiosRequestConfig): Promise<T> {
  return unwrap<T>(await api.get(url, config))
}

export async function sendApiData<T>(
  method: 'post' | 'put' | 'delete',
  url: string,
  data?: unknown,
  config?: AxiosRequestConfig,
): Promise<T> {
  return unwrap<T>(await api.request({ url, method, data, ...config }))
}
